import React from "react";
import "../Css/Accounts.css";
import {Tooltip} from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import {Profile} from "../types";

interface ProfileSectionProps {
    profile?: Profile
}

export function ProfileSection({profile}: ProfileSectionProps) {
    return (
        <section className="cv-profile">
            <div className="cv-photo">
                <img src={profile?.src} alt={profile?.name}/>
                {profile?.linkedin && (
                    <Tooltip title="View LinkedIn profile" arrow placement="bottom">
                        <a
                            href={profile.linkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cv-linkedin"
                            aria-label={`${profile.name} on LinkedIn`}
                        >
                            <LinkedInIcon/>
                        </a>
                    </Tooltip>
                )}
            </div>
            <div className="cv-summary">
                <h2>{profile?.title}</h2>
                <blockquote>{profile?.quote}</blockquote>
            </div>
        </section>
    );
}
